import React, { useCallback } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

const BackAnchor = ({ t, i18n, backPath, isInternal = true, onBackClick }) => {
  const history = useHistory()

  const handleGoBack = useCallback(
    (e) => {
      e.preventDefault()
      if (backPath) {
        if (isInternal) {
          history.push(`/${i18n.language}${t(backPath)}`)
        } else {
          window.location.href = t(backPath)
        }
      } else {
        history.goBack()
      }
    },
    [history, onBackClick, backPath, i18n.language, t]
  )

  return (
    <div className="row">
      <div className="col-xs-12">
        <div style={{ marginTop: '-33px' }}>
          <a onClick={handleGoBack} href={`/${i18n.language}${t(backPath)}`} className="ns-back-link" style={{ textDecoration: 'none' }}>
            <i className="fa fa-arrow-left fa-md" aria-hidden="true"></i> {t('shared.back')}
            <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
          </a>
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(BackAnchor)
